export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11316.14d25422.jpg";